export default __webpack_public_path__ + "static/media/lb-hackathon-level-1.07ec6d75.svg";